import React from 'react';
import { Input,  } from "reactstrap";

type Props = {
  value: string,
  onChange: any
}

export const AppSearchForm = ({ value, onChange }: Props) => {
  return (
    <div>
      <Input
        className="form-control-alternative fancy-input"
        placeholder="search"
        type="text"
        value={value}
        onChange={onChange}
        style={{ height: '45px', border: 'none' }}
      />
    </div>
  );
}


